document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('section.section-filters') || document;
  const form = section.querySelector('form.section-filters-form');

  const collectionSelect = section.querySelector('select.dropdown-collection');
  const collectionInput  = section.querySelector('input.input-collection');
  function pickSelect(label) {
    // 1) If the SELECT itself has data-label
    const direct = section.querySelector(`select[data-label="${label}"]`);
    if (direct) return direct;

    // 2) If a wrapper has data-label, find the SELECT inside it
    const wrap = section.querySelector(`[data-label="${label}"]`);
    if (!wrap) return null;

    return wrap.querySelector('select') || null;
}


  const makeEl  = pickSelect('Make');
  const modelEl = pickSelect('Model');
  const yearEl  = pickSelect('Year');

  const submitBtn = section.querySelector('button[type="submit"]');

  if (!form || !makeEl || !modelEl || !yearEl) return;

  console.log('[YMM] elements', {
    makeTag: makeEl.tagName,
    modelTag: modelEl.tagName,
    yearTag: yearEl.tagName
  });


  const FILTER_MAKE  = 'filter.p.m.custom.car_make';
  const FILTER_MODEL = 'filter.p.m.custom.car_model';
  const FILTER_YEAR  = 'filter.p.m.custom.car_year';

  const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)));
  const sortAZ = (arr) => arr.slice().sort((a,b) => a.localeCompare(b));
  const sortYearsDesc = (arr) => arr.slice().sort((a,b) => (parseInt(b,10)||0) - (parseInt(a,10)||0));

  // Fallback if ymmClean wasn't defined globally yet
  const ymmCleanSafe = (typeof window.ymmClean === 'function')
    ? window.ymmClean
    : (val) => String(val || '').replace(/\s+/g, ' ').trim();


  function resetSelect(selectEl, label) {
    selectEl.innerHTML = '';
    const opt = document.createElement('option');
    opt.className = 'default';
    opt.value = '';
    opt.selected = true;
    opt.disabled = true;
    opt.textContent = label;
    selectEl.appendChild(opt);
  }

  function disableSelect(selectEl) {
    selectEl.disabled = true;
    selectEl.closest('.form-group')?.classList.add('disabled');
  }

  function enableSelect(selectEl) {
    selectEl.disabled = false;
    selectEl.closest('.form-group')?.classList.remove('disabled');
  }

  function getSelectedCollectionUrl() {
    if (collectionSelect) return collectionSelect.value || '';
    if (collectionInput) return collectionInput.value || '';
    return '';
  }

  // --------- NEW DATA SOURCE (fetch + cache) ----------
  const ymmCache = {};   // { [collectionUrl]: items[] }
  const ymmLoad  = {};   // { [collectionUrl]: Promise<items[]> }

  async function fetchAllItems(collectionUrl) {
    let page = 1;
    const all = [];

    while (true) {
      const u = new URL(collectionUrl, window.location.origin);
      u.searchParams.set('view', 'ymm-json');
      u.searchParams.set('page', String(page));
      const endpoint = u.toString();

      const res = await fetch(endpoint, { credentials: 'same-origin' });
      if (!res.ok) break;

      const txt = await res.text();

      // If the endpoint ever returns HTML by mistake, stop and log it.
      let data;
      try {
        data = JSON.parse(txt);
      } catch (e) {
        console.error('YMM endpoint did not return JSON:', endpoint, txt.slice(0, 200));
        break;
      }

      const batch = data?.products || [];
      all.push(...batch);

      if (!data?.has_more) break;

      // safety guard – prevents infinite loop if something goes wrong
      if (page > 50) break;
      
      page++;
    }

    return all
      .filter(x => x && x.make && x.model)
      .map(x => {
        const yrs = Array.isArray(x.years) ? x.years : (x.years ? [x.years] : []);
        return {
          make: ymmCleanSafe(x.make),
          model: ymmCleanSafe(x.model),
          years: yrs.map(y => String(y))
        };
      });
  }

  async function getItemsForCollection(collectionUrl) {
    if (!collectionUrl) return [];
    if (ymmCache[collectionUrl]) return ymmCache[collectionUrl];

    if (!ymmLoad[collectionUrl]) {
      ymmLoad[collectionUrl] = fetchAllItems(collectionUrl).then(items => {
        ymmCache[collectionUrl] = items;
        return items;
      }).finally(() => {
        delete ymmLoad[collectionUrl];
      });
    }
    return ymmLoad[collectionUrl];
  }

  function initState() {
    resetSelect(makeEl, 'Make');
    resetSelect(modelEl, 'Model');
    resetSelect(yearEl, 'Year');

    disableSelect(makeEl);
    disableSelect(modelEl);
    disableSelect(yearEl);

    if (submitBtn) submitBtn.disabled = true;
  }

  async function fillMakes(collectionUrl) {
    initState();
    if (!collectionUrl) return;

    // show loading
    makeEl.querySelector('option.default').textContent = 'Loading...';

    const items = await getItemsForCollection(collectionUrl);
    if (!items.length) return;

    const makes = sortAZ(uniq(items.map(i => i.make)));
    resetSelect(makeEl, 'Make');

    makes.forEach(m => {
      const opt = document.createElement('option');
      opt.value = m;
      opt.textContent = m;
      makeEl.appendChild(opt);
    });

    enableSelect(makeEl);
  }

  async function fillModels(collectionUrl, make) {
    resetSelect(modelEl, 'Model');
    resetSelect(yearEl, 'Year');
    disableSelect(modelEl);
    disableSelect(yearEl);
    if (submitBtn) submitBtn.disabled = true;

    if (!collectionUrl || !make) return;

    modelEl.querySelector('option.default').textContent = 'Loading...';

    const makeClean = ymmCleanSafe(make);
    const items = await getItemsForCollection(collectionUrl);

    const models = sortAZ(
      uniq(items.filter(i => ymmCleanSafe(i.make) === makeClean).map(i => ymmCleanSafe(i.model)))
    );

    resetSelect(modelEl, 'Model');
    models.forEach(md => {
      const opt = document.createElement('option');
      opt.value = md;
      opt.textContent = md;
      modelEl.appendChild(opt);
    });

    if (models.length) enableSelect(modelEl);
  }

  async function fillYears(collectionUrl, make, model) {
    resetSelect(yearEl, 'Year');
    disableSelect(yearEl);
    if (submitBtn) submitBtn.disabled = true;

    if (!collectionUrl || !make || !model) return;

    yearEl.querySelector('option.default').textContent = 'Loading...';

    const makeClean  = ymmCleanSafe(make);
    const modelClean = ymmCleanSafe(model);

    const items = await getItemsForCollection(collectionUrl);
    const years = [];

    items.forEach(i => {
      if (ymmCleanSafe(i.make) === makeClean && ymmCleanSafe(i.model) === modelClean) {
        i.years.forEach(y => years.push(String(y)));
      }
    });

    const ylist = sortYearsDesc(uniq(years));

    resetSelect(yearEl, 'Year');
    ylist.forEach(y => {
      const opt = document.createElement('option');
      opt.value = y;
      opt.textContent = y;
      yearEl.appendChild(opt);
    });

    if (ylist.length) enableSelect(yearEl);
    if (submitBtn) submitBtn.disabled = !makeEl.value;
  }

  function buildUrl(collectionUrl, make, model, year) {
    const url = new URL(collectionUrl, window.location.origin);

    url.searchParams.set(FILTER_MAKE, make);

    if (model) url.searchParams.set(FILTER_MODEL, model);
    else url.searchParams.delete(FILTER_MODEL);

    if (year) url.searchParams.set(FILTER_YEAR, year);
    else url.searchParams.delete(FILTER_YEAR);

    return url.toString();
  }

  // --------- events ----------
  initState();

  if (collectionSelect) {
    collectionSelect.addEventListener('change', () => {
      fillMakes(getSelectedCollectionUrl());
    });
  }

  if (!collectionSelect && collectionInput?.value) {
    fillMakes(collectionInput.value);
  }

  makeEl.addEventListener('change', () => {
    fillModels(getSelectedCollectionUrl(), makeEl.value);
  });

  modelEl.addEventListener('change', () => {
    fillYears(getSelectedCollectionUrl(), makeEl.value, modelEl.value);
  });

  yearEl.addEventListener('change', () => {
    if (submitBtn) submitBtn.disabled = !makeEl.value;
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const collectionUrl = getSelectedCollectionUrl();
    const make = makeEl.value;
    const model = modelEl.value;
    const year = yearEl.value;

    if (!collectionUrl || !make) return;

    window.location.href = buildUrl(collectionUrl, make, model, year);
  });
});
